import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { Router } from "@angular/router";

export const authGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    // ToDo: replace for the login app URL
    // return auth.isLogedIn || router.parseUrl('https://demoapp.day1cloud.com/');
    if(auth.isLogedIn) {
        return true;
    }
    auth.login();
    return false;
}
